var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("c-step", {
    attrs: {
      stepperGrpCd: "LICENSE_REQUEST_STEP_CD",
      param: _vm.param,
      currentStepCd: _vm.stepCd,
    },
    on: {
      currentStep: _vm.currentStep,
      setId: _vm.setId,
      closePopup: _vm.closePopup,
    },
    model: {
      value: _vm.stepCd,
      callback: function ($$v) {
        _vm.stepCd = $$v
      },
      expression: "stepCd",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }